<div class="about">
  <div class="left">
    <h1>PixelArtist is a free online editor for animated sprites & pixel art</h1>
    <p>Create animations in your browser.
      Try an example, use Google sign in to access your gallery or simply create a new sprite.</p>
    <div class="about-buttons">
      <app-log-in-about-button></app-log-in-about-button>
      <app-create-sprite-about-button></app-create-sprite-about-button>
    </div>
  </div>
  <div class="right">

  </div>
</div>
